import * as types from '../actions/actionTypes';
import initialState from './initialState';
  
export default function moduloReducer(state= initialState.modulo, action){
    let newState;
	switch(action.type){
         case types.LOAD_MODULO_LIST_SUCCESS:		
            action.modulo.filtroActivo=state.filtroActivo;
            action.modulo.filtroActual=state.filtroActual;
            action.modulo.showActivos=state.showActivos;
            action.modulo.filtrosCombo=state.filtrosCombo;
            action.modulo.paginaActual=action.modulo.pageable.pageNumber;
            action.modulo.registrosPorPagina=action.modulo.size;
            
            return action.modulo;

        case types.BORRAR_MODULO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(modulo => modulo.id !== action.modulo.id)];          
			return newState;    
            
        case types.ACTIVAR_MODULO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(modulo => modulo.id !== action.modulo.id)];          
			 return newState;
            
        case types.SET_FILTRO_MODULO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
            newState.showActivos=action.filtro.showActivos;
            newState.filtrosCombo=action.filtro.filtrosCombo;
            
			return newState;
		break;
            
		default:
			return state;
	}
}